import React from 'react';
import { Award, Zap, FileText, Send, Flame, Star } from 'lucide-react';
import { Badge } from '../data/mockData';
const badgeConfig: Record<Badge, {
  icon: React.ElementType;
  color: string;
  bg: string;
}> = {
  'Top Closer': {
    icon: Award,
    color: 'text-yellow-600',
    bg: 'bg-yellow-100'
  },
  'Submission King': {
    icon: Send,
    color: 'text-blue-600',
    bg: 'bg-blue-100'
  },
  'Doc Machine': {
    icon: FileText,
    color: 'text-purple-600',
    bg: 'bg-purple-100'
  },
  'Hot Streak': {
    icon: Flame,
    color: 'text-red-600',
    bg: 'bg-red-100'
  },
  'Rising Star': {
    icon: Star,
    color: 'text-orange-600',
    bg: 'bg-orange-100'
  }
};
export function MetricBadge({
  badge
}: {
  badge: Badge;
}) {
  const config = badgeConfig[badge];
  if (!config) return null;
  const Icon = config.icon;
  return <div className={`flex items-center gap-1 px-2 py-1 rounded-full text-xs font-semibold ${config.bg} ${config.color}`} title={badge} data-id="element-77">
      <Icon className="w-3 h-3" data-id="element-78" />
      <span className="hidden xl:inline" data-id="element-79">{badge}</span>
    </div>;
}